import React, { useEffect } from 'react';
import FormGroup from './FormGroup';
import { Controller } from 'react-hook-form';
import { CompactPicker } from 'react-color';
import icons from '../../constants/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

/** Props for FormColourPicker - most are optional */
export interface FormColourPickerProps {
  name?: string;
  control: any;
  label?: string;
  defaultValue?: string;
  placeholder?: string;
  register?: any;
  error?: any;
  errorMessage?: string;
  required?: boolean;
  extraRowClasses?: string;
  disabled?: boolean;
  testId?: string;
}

const FormColourPicker = ({
  label,
  name,
  defaultValue,
  placeholder,
  register,
  error,
  errorMessage,
  control,
  required,
  extraRowClasses = 'align-items-start',
  disabled,
  testId,
}: FormColourPickerProps) => {
  const { t } = useTranslation();
  const [state, setState] = React.useState({
    displayColorPicker: false,
  });

  const [editorState, setEditorState] = React.useState({
    background: 'transparent',
  });

  useEffect(() => {
    setEditorState({
      background: defaultValue ?? 'transparent',
    });
  }, [defaultValue]);

  const handleChangeComplete = (
    color: { hex: string },
    onChange: (value: string) => void
  ) => {
    setEditorState({
      background: color.hex,
    });
    onChange(color.hex);
  };

  const popover: React.CSSProperties = {
    position: 'absolute',
    zIndex: 2,
  };
  const cover: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  };

  const handleOpen = () => {
    setState({ displayColorPicker: !state.displayColorPicker });
  };

  const handleClose = () => {
    setState({ displayColorPicker: false });
  };

  return (
    <FormGroup
      label={label}
      extraRowClasses={extraRowClasses}
      error={Boolean(error)}
      errorMessage={errorMessage}
      required={required}
    >
      <Controller
        name={name ?? ''}
        control={control}
        defaultValue={defaultValue ?? 'transparent'}
        render={({ field: { onChange } }) => (
          <div>
            <div style={{ display: 'flex' }}>
              <button
                onClick={handleOpen}
                disabled={disabled ?? false}
                style={{
                  backgroundColor: editorState.background,
                  width: 34,
                  height: 34,
                }}
                title={t('Pick colour')}
                data-cy={testId}
              />
              <button
                className="btn btn-default ms-2 btn--square"
                title={t('Clear colour')}
                onClick={() => {
                  handleChangeComplete({ hex: 'transparent' }, onChange);
                }}
              >
                <FontAwesomeIcon icon={icons.DELETE} fixedWidth />
              </button>
            </div>
            {state.displayColorPicker ? (
              <div style={popover} data-cy={`${testId ?? ''}-popover`}>
                <div style={cover} onClick={handleClose} />
                <CompactPicker
                  color={editorState.background}
                  onChangeComplete={(color: { hex: string }) =>
                    handleChangeComplete(color, onChange)
                  }
                />
              </div>
            ) : null}
          </div>
        )}
      />
    </FormGroup>
  );
};
export default FormColourPicker;
